import React from 'react';
import PropTypes from 'prop-types';
import Button from '../Button';
import styles from './FiltersMobileBtn.module.less';

const FiltersMobileBtn = ({ onClick }) => {
  return (
    <div className={styles.container}>
      <Button className={styles.button} color="tertiary" onClick={onClick}>
        <img
          alt="icon-sliders"
          src="https://cdn.education.com/files/static/icon-svg/icon-sliders.svg"
          className={styles.slidersIcon}
        />
        <div className={styles.filterBtnText}>All filters</div>
      </Button>
    </div>
  );
};

FiltersMobileBtn.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default FiltersMobileBtn;
